import { AthleteLinks } from "../../../../parts/athlete-links";
import { AthleteSelect } from "../../../../parts/inputs/athlete-select-new";
import ToggleLinksInput from "../../../../parts/inputs/toggle-links-input";
import getAvatarUrl from "../../../../utils/get-avatar-url";

function MobileAthleteHeader({
  athlete,
  pathname,
  query,
  locals,
  viewOptions,
}) {
  return (
    <div className="athlete-section-header only-show-mobile">
      <AthleteLinks
        athlete={athlete}
        pathName={pathname}
        classNames="only-show-mobile"
        query={query}
      />
      <div>
        <div className="athlete-select dropdown-athlete">
          <div
            className="avatar"
            style={{
              backgroundImage: `url(${getAvatarUrl(athlete?._id)})`,
            }}
          />
          <AthleteSelect locals={locals} />
        </div>
        <ToggleLinksInput name="view" options={viewOptions} />
      </div>
    </div>
  );
}

export default MobileAthleteHeader;
